import { styled } from "@mui/system"
import { Box, Paper } from "@mui/material"

export const PDFErrorDisplay = styled(Paper)({
  display: "flex",
  padding: "32px 32px 56px 32px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "32px",
  borderRadius: "4px",
})
